<script setup lang="ts">
  import { WEEKDAYS } from '@/shared/lib';
</script>

<template>
  <div class="grid grid-cols-7 mb-2">
    <div
      v-for="day in WEEKDAYS"
      :key="day"
      class="text-center text-sm font-medium text-gray-07"
    >
      {{ day }}
    </div>
  </div>
</template>
